export default "__VITE_ASSET__PrLoDoiW__"